/*
 *  -----------------------------------------------------------------------
 *    <copyright file="generation-history/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { ReportModules } from '@interfaces/report-templates.interface';
import React from 'react';
import PageTitle from '@components/core/page-title/page-title';
import GeneratedReportsGrid from '@components/shared/manage-reports-templates/generated-reports-grid';
import { useAuthorization, useTranslation } from '@hooks/index';
import Constants from '@utils/constants';

const GenerationHistory = ({ module }: ReportModules) => {
    const { t } = useTranslation();
    const user = useAuthorization();

    const orgKey = user?.organisationKey ?? Constants.ObjectId.Empty;

    return (
        <>
            <div className="k-mb-2.5">
                <PageTitle text={t('cm:generationHistory')} />
            </div>
            <GeneratedReportsGrid orgKey={orgKey} module={module} isGenerationHistory />
        </>
    );
};

export default GenerationHistory;
